<template>
  <div class="streamer-type-card">
    <settings-card
      :config="config"
      @setting="settings"></settings-card>
    <company-brand-image-modal ref="modal" />
  </div>
</template>
<script>
import SettingsCard from '../settings-card.vue'
import CompanyBrandImageModal from './company-brand-image-modal.vue'
import { cardMixin } from '../mixin'
export default {
  name: 'CompanyBrandImageCard',
  components: { SettingsCard, CompanyBrandImageModal },
  mixins: [cardMixin]
}
</script>
